export const formatStringDate = (dateString: string ): string => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString("fr-FR");
  };

export const genererNumeroContrat=() =>{
    const maintenant = new Date();
  
    const yy = String(maintenant.getFullYear()).slice(2); // 2 derniers chiffres de l'année
    const mm = String(maintenant.getMonth() + 1).padStart(2, '0'); // Mois (0-11 → 1-12)
    const dd = String(maintenant.getDate()).padStart(2, '0');
    const hh = String(maintenant.getHours()).padStart(2, '0');
    const min = String(maintenant.getMinutes()).padStart(2, '0');
  
    return `CT${yy}${mm}${dd}${hh}${min}`;
  }
/**
 * Récupère le prochain numéro de document depuis l'API (incrémentation atomique).
 * Le numéro est formaté : {prefix}{numero sur 6 chiffres}, ex: "FAC-000001"
 */
/**
 * Récupère le prochain numéro de document depuis l'API (incrémentation atomique).
 * Le numéro est formaté : {prefix}{numero sur 6 chiffres}, ex: "FAC-000001"
 */
export const getNextNumeroDocument = async (
  doc_code:       string,
  prefix:         string,
  departement_id: number = 0
): Promise<string> => {
  const api = (await import("../reduxStore/api")).default;
  const response = await api.get<{ numero_doc: string }>("/numerotation/next", {
    params: { doc_code, prefix, departement_id },
  });
  return response.data.numero_doc;
};

  // formatNumber.js
// Affichage monétaire : arrondi à 2 décimales max (évite les flottants
// type 18.999999998 issus des calculs HT/TVA), séparateur de milliers.
export const formatNumberWithSpaces=(num:number|null)=>{
  const n = Number(num);
  // Valeur manquante ou non numérique (null/undefined/NaN/Infinity) → '0'.
  if (!Number.isFinite(n)) return "0";
  const rounded = Math.round((n + Number.EPSILON) * 100) / 100;
  // On conserve les décimales, mais on retire les 0 inutiles en fin
  // (5.50 → 5.5, 5.00 → 5, 5.05 → 5.05) : un 0 traînant n'a pas de sens.
  const [intPart, decPartRaw = ''] = rounded.toFixed(2).split('.');
  const decPart = decPartRaw.replace(/0+$/, '');
  const intFormatted = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  return decPart ? `${intFormatted}.${decPart}` : intFormatted;
}

  